<template>
  <div class="restaurant-card-wrapper">
    <div class="restaurant-card-header">
      <Skeleton height="48px" width="48px" round />
      <Skeleton height="44px" />
    </div>
    <Skeleton height="24px" />
    <Skeleton height="112px" />
    <perfect-scrollbar class="restaurant-card-pills">
      <Skeleton v-for="item in 3" :key="item" height="28px" width="124px" />
    </perfect-scrollbar>
    <perfect-scrollbar class="restaurant-card-pills">
      <Skeleton v-for="item in 2" :key="item" height="46px" width="124px" />
    </perfect-scrollbar>
    <perfect-scrollbar class="restaurant-card-images">
      <Skeleton v-for="photo in 3" :key="photo" height="160px" width="260px" />
    </perfect-scrollbar>
    <Skeleton height="44px" width="250px" />
  </div>
</template>

<script>
import "swiper/css/bundle";
import Skeleton from "@/components/ui/Skeleton.vue";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";

export default {
  name: "RestaurantCardMobileSkeleton",
  components: {
    Skeleton,
    PerfectScrollbar,
  },
};
</script>

<style lang="scss" scoped>
.restaurant-card {
  &-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #00000014;
  }

  &-images {
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;
    padding-bottom: 12px;
    div {
      flex: 0 0 auto;
    }
  }

  &-header {
    display: flex;
    align-items: center;
    gap: 8px;

    div:first-child {
      flex: 0 0 auto;
    }
  }

  &-pills {
    display: flex;
    gap: 10px;
    flex-wrap: nowrap;

    div {
      flex: 0 0 auto;
    }
  }
}

.restaurant-info {
  display: flex;
  gap: 12px;

  &-item {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #858585;
  }

  &-value {
    font-weight: 600;
    color: #222222;
  }
}
</style>
